module.exports = __webpack_public_path__ + "assets/webgl/360_vignes.d010e283.jpg";